module.exports = __webpack_public_path__ + "static/img/main-bg.53781d1b.png";